import { Save, Trash2 } from "lucide-react";

const cls = "px-2 py-1.5 text-sm border border-slate-300 rounded-md bg-white focus:border-emerald-500 outline-none";

// Kayıtlı şablon seç / adlandırıp kaydet / sil + Tümünü seç / Temizle
export default function TemplateBar({ tpls, tplId, name, setName, onApply, onSave, onDelete, onAll, onNone, testid }) {
  return (
    <div className="flex flex-wrap items-center gap-2 border-b border-slate-200 pb-3">
      <select value={tplId} onChange={(e) => onApply(e.target.value)} className={`${cls} w-56`} data-testid={`${testid}-template-select`}>
        <option value="">Kayıtlı şablon seç…</option>
        {tpls.map((t) => <option key={t.id} value={t.id}>{`${t.name} (${t.columns.length} sütun)`}</option>)}
      </select>
      {tplId && <button type="button" onClick={onDelete} className="p-1.5 rounded border border-red-200 text-red-600 hover:bg-red-50" title="Şablonu sil" data-testid={`${testid}-template-delete`}><Trash2 className="w-3.5 h-3.5" /></button>}
      <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Şablon adı (yeni / güncelle)" data-no-upper="true" className={`${cls} w-56`} data-testid={`${testid}-template-name`} />
      <button type="button" onClick={onSave} className="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-md border border-slate-300 bg-white text-xs font-semibold hover:bg-slate-50" data-testid={`${testid}-template-save`}><Save className="w-3.5 h-3.5" /> Şablonu Kaydet</button>
      <span className="ml-auto flex gap-2 text-xs">
        <button type="button" onClick={onAll} className="underline text-slate-600" data-testid={`${testid}-select-all`}>Tümünü seç</button>
        <button type="button" onClick={onNone} className="underline text-slate-600" data-testid={`${testid}-select-none`}>Temizle</button>
      </span>
    </div>
  );
}
